import { Component } from '@angular/core';
import { NormalNavbar } from '../../../../layout/normal-navbar/normal-navbar';
import { SeasonDetails } from '../../components/seasons/season-details/season-details';
import { CommonModule } from '@angular/common';
import { Footer } from '../../../../layout/footer/footer.component';

@Component({
  selector: 'app-seasons',
  imports: [NormalNavbar, SeasonDetails, CommonModule, Footer],
  templateUrl: './seasons.html',
  styleUrl: './seasons.scss'
})

export class Seasons {

}
